export default "__VITE_ASSET__duPjuJrh__"